// @flow

import * as React from 'react';

import { Select } from 'gandi.react-form';

const SimpleSelect = (props: {|
  input: any,
  meta: any,
  defaultValue: string,
|}): React.Element<typeof Select> => {
  const { input, meta, defaultValue, ...extraProps } = props;
  const fieldProps = {
    ...input,
    ...extraProps,
    value: defaultValue,
  };

  return <Select {...fieldProps} />;
};

export default SimpleSelect;
